import { TreatmentType } from "@redotech/redo-ab-testing-common/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const rescuePanelTreatmentMetricsSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  numTargetedShoppers: z.number(),
  numEngagements: z.number(),
  engagementRate: z.number(),
  numOrdersPlaced: z.number(),
  conversionRate: z.number(),
  aov: z.number(),
  revenuePerTargetedShopper: z.number(),
});

const rescuePanelSplitWithMetricsSchema = z.object({
  splitId: zExt.objectId(),
  splitName: z.string(),
  active: z.boolean(),
  startDate: z.date(),
  endDate: z.date().nullable().optional(),
  treatmentType: z.literal(TreatmentType.RESCUE_PANEL),
  treatmentMetrics: z.array(rescuePanelTreatmentMetricsSchema),
  onlineStoreOrdersCount: z.number(),
});
export type RescuePanelSplitWithMetrics = z.infer<
  typeof rescuePanelSplitWithMetricsSchema
>;

export const getRescuePanelSplitsWithMetrics = {
  name: "getRescuePanelSplitsWithMetrics" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(rescuePanelSplitWithMetricsSchema),
};
